import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { checkSec, expireSession } from "../../actions/auth";
import { loadUi } from "../../actions/search";
import { getUserGlb } from "../../actions/userGlb";
import { ERR_MSG_SESSION_EXPIRED } from "../../ErrorMessages";
import SideInfoPane from "../navigation/SideInfoPane";
import api from "../../api";
import SecurityQuestions from "./SecurityQuestions";
import SecurityQuestionsSetupForm from "../forms/SecurityQuestionsSetupForm";

class SecurityQuestionsCheck extends Component {
  constructor(props) {
    super(props);
    api.user
      .checkQaSetup({
        usercode: props.userid,
      })
      .then((result) => {
        if (result.data.Status === "Error")
          this.setState({ securityCheck: false });
      });
  }

  state = {
    loading: false,
    securityCheck: true,
  };

  submitSecurityQuestions = (questionSets) => {
    const qaList = [];
    let qaItem;
    _.forEach(questionSets, (questionSet) => {
      qaList.push({
        id: questionSet.selected.id,
        value: questionSet.selected.value.toUpperCase(),
      });
      if (!qaItem) {
        const selectedOption = _.find(
          questionSet.options,
          (o) => o.value === questionSet.selected.id
        );
        if (selectedOption) {
          qaItem = {
            question: selectedOption.text,
            answer: questionSet.selected.value.toUpperCase(),
          };
        }
      }
    });
    this.setState({ loading: true, qaItem });
    return api.user
      .setupQa(this.props.userid, qaList)
      .then((result) => {
        if (result.data.Status === "Error") {
          this.setState({
            securityQuestionsSetupError: result.data.Message,
            loading: false,
          });
        } else {
          this.props
            .checkSec([qaItem])
            .then((res) => {
              if (res.data.Status === "Error") {
                if (res.data.Message === "Answer does not match") {
                  this.setState({ loading: false });
                  localStorage.removeItem("sessionID");
                } else {
                  this.props.expireSession(ERR_MSG_SESSION_EXPIRED);
                  return;
                }
              }
              if (localStorage.sessionID) {
                this.props
                  .getUserGlb()
                  .then(() => {
                    this.props
                      .loadUi()
                      .then(() => {
                        window.location.href = `/searchOptions`;
                      })
                      .catch((err) => {
                        console.log(
                          "Error during loadui - ",
                          err,
                          " - ",
                          err.response
                        );
                        this.setState({ loading: false });
                      });
                  })
                  .catch((err) => {
                    console.log(
                      "Error while fetch user glb - ",
                      err,
                      " - ",
                      err.response
                    );
                    this.setState({ loading: false });
                  });
              } else {
                this.setState({ respData: res.data.QAErrorList });
              }
            })
            .catch((err) => {
              console.log("Error during checkSec", err);
              this.props.expireSession(ERR_MSG_SESSION_EXPIRED);
            });
        }
      })
      .catch((err) => {
        this.setState({ errors: err.response.data.errors, loading: false });
      });
  };

  submit = (data) => {
    this.setState({ loading: true });
    return this.props
      .checkSec(data.qaList)
      .then((res) => {
        if (res.data.Status === "Error") {
          if (res.data.Message === "Answer does not match") {
            this.setState({ loading: false });
            localStorage.removeItem("sessionID");
          } else {
            this.props.expireSession(ERR_MSG_SESSION_EXPIRED);
            return;
          }
        }
        if (localStorage.sessionID) {
          this.props
            .getUserGlb()
            .then(() => {
              this.props
                .loadUi()
                .then(() => {
                  window.location.href = `/searchOptions`;
                })
                .catch((err) => {
                  console.log(
                    "Error during loadui - ",
                    err,
                    " - ",
                    err.response
                  );
                  this.setState({ loading: false });
                });
            })
            .catch((err) => {
              console.log(
                "Error while fetch user glb - ",
                err,
                " - ",
                err.response
              );
              this.setState({ loading: false });
            });
        } else {
          this.setState({ respData: res.data.QAErrorList });
        }
      })
      .catch((err) => {
        console.log("Error during checkSec", err);
        this.props.expireSession(ERR_MSG_SESSION_EXPIRED);
      });
  };

  render() {
    return this.state.securityCheck ? (
      <SecurityQuestions {...this.props} />
    ) : (
      <div className="row login-box">
        <div className="row">
          <div className="col-lg-1 col-md-1 col-sm-1" />
          <div className="col-lg-5 col-md-5 col-sm-5 login-box-left">
            <div className="padding-top-10" />

            <h2 className="font-family">Security Questions Set Up</h2>
            <SecurityQuestionsSetupForm
              username={this.props.userid}
              submit={this.submitSecurityQuestions}
              securityQuestionsSetupError={
                this.state.securityQuestionsSetupError
              }
            />
            <div className="padding-top-10" />

            <div className="padding-top-20 hide-on-smallscreen padding-top-3" />
          </div>

          <div className="col-lg-2 col-md-2 col-sm-2" />
          <div className="col-lg-4 col-md-4 col-sm-4 login-box-right padding-top-25">
            <SideInfoPane />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, { checkSec, expireSession, getUserGlb, loadUi })(
  SecurityQuestionsCheck
);



// WEBPACK FOOTER //
// ./src/components/pages/SecurityQuestionsCheck.js